/* @jsx h */
import { labels } from '../config';
import { Fragment } from 'preact';
import { useRef, useEffect } from 'preact/hooks';
import Default from './Result/Default';
import Event from './Result/Event';
import News from './Result/News';
import Page from './Result/Page';
import Publication from './Result/Publication';
import VisibilityMeasure from './Result/VisibilityMeasure';

const ResultContainer = ({ allResultCount, list, activeFacets }) => {
  const paginationInputEl = useRef(null);

  useEffect(() => {
    if (paginationInputEl && paginationInputEl.current) {
      paginationInputEl.current.value = '';
    }
  }, []);

  return (
    <Fragment>
      <section className="search-result">
        <h2 className="search-result__heading sr-only">
          {labels.results.results}
        </h2>
        {activeFacets.length > 0 && (
          <p className="search-result__count">
            {allResultCount === 1
              ? labels.results.foundSingular
              : labels.results.found.replace('@resultsTotal', allResultCount)}
          </p>
        )}
        <ul className="search-result__list">
          {list.map(result => {
            switch (result.type) {
              case 'event':
                return <Event result={result} key={result.uid} />;
              case 'news':
                return <News result={result} key={result.uid} />;
              case 'page':
                return <Page result={result} key={result.uid} />;
              case 'publication':
                return <Publication result={result} key={result.uid} />;
              case 'visibilityMeasure':
                return <VisibilityMeasure result={result} key={result.uid} />;
              default:
                return <Default result={result} key={result.uid} />;
            }
          })}
        </ul>
      </section>
    </Fragment>
  );
};

export default ResultContainer;
